import React from 'react';
import { Button } from 'venn-ui-kit';
import type { AnalysisSubject } from 'venn-utils';
import { MANAGE_DATA_SECTION } from 'venn-utils';
import type { RangeDebugGroup } from '../../../hooks/useRangesDebug';
import { getRangeFrequency } from '../PortfolioRangesUtils';
import { EmptyStateContent, Frequency } from '../components/styled';
import { ManageDataLink } from '../../../manage-data';

interface ErrorConstrainedFrequencyProps {
  subject: AnalysisSubject;
  rangeDebugGroup?: RangeDebugGroup;
  regressionName: string;
}

// TODO(VENN-24534): add a display name to this React component
// eslint-disable-next-line react/display-name
export default ({ subject, rangeDebugGroup, regressionName }: ErrorConstrainedFrequencyProps) => {
  const portfolioRange = rangeDebugGroup?.primary?.response?.portfolioRange;
  if (!portfolioRange) {
    return null;
  }

  const totalFrequency = getRangeFrequency(portfolioRange);

  // @ts-expect-error: fixme
  const customRenderer = (onClick) => (
    <div>
      <p>
        Go to{' '}
        <button type="button" onClick={onClick} className="text-venn-dark-blue hover:text-venn-dark-blue/90 font-bold">
          Manage Data
        </button>{' '}
        to apply proxies.
      </p>
      <Button className="print:hidden" onClick={onClick} dominant refreshedStyling>
        Manage Data
      </Button>
    </div>
  );

  return (
    <EmptyStateContent style={{ maxWidth: '100%' }}>
      Cannot run {regressionName} for a <Frequency>{totalFrequency}</Frequency> analysis, <Frequency>daily</Frequency>{' '}
      or <Frequency>monthly</Frequency> frequency is required.
      {
        // TODO(houssein): Refactor ManageDataLink to a custom navigation hook
        <ManageDataLink
          subject={subject}
          defaultEditData
          customRenderer={customRenderer}
          forceSection={MANAGE_DATA_SECTION.ANALYSIS_RANGE}
          errorState
        />
      }
    </EmptyStateContent>
  );
};
